<div>
  <img class="error" src="assets/icons/error.svg" alt="error" />
  <app-onboarding-header
    title="No se pudo crear la cuenta"
    subtitle="El usuario no se encuentra habilitado para operar"
  ></app-onboarding-header>
</div>
